import React, { createContext, useState, useContext, useEffect } from 'react';

// Create Context
const PaginationContext = createContext();

// Custom Hook to use the Pagination Context
export const usePagination = () => {
  return useContext(PaginationContext);
};

// PaginationProvider Component
export const PaginationProvider = ({ children }) => {
  const [pagination, setPagination] = useState({
    current: JSON.parse(localStorage.getItem('currentPageMSR')) || 1,
    pagesize: JSON.parse(localStorage.getItem('PageSize')) || 20,
    loading: false,
    specialfilter: JSON.parse(localStorage.getItem('specialfilter')) || null,
    search: JSON.parse(localStorage.getItem('search')) || '',
    advancedSearch: JSON.parse(localStorage.getItem('advancedSearchMSR')) || null,
    orderby: [],
  });

  // Update localStorage whenever pagination state changes
  useEffect(() => {
    localStorage.setItem('currentPageMSR', JSON.stringify(pagination.current));
    localStorage.setItem('specialfilter', JSON.stringify(pagination.specialfilter));
    localStorage.setItem('PageSize', JSON.stringify(pagination.pagesize));
    localStorage.setItem('search', JSON.stringify(pagination.search));
    localStorage.setItem('advancedSearchMSR', JSON.stringify(pagination.advancedSearch));
  }, [pagination]);

  return (
    <PaginationContext.Provider value={{ pagination, setPagination }}>
      {children}
    </PaginationContext.Provider>
  );
};
